/* eslint-disable camelcase */
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { IApiResponse } from '@core/interfaces/api-response.interface';
import { EMaterialType } from '@enums/campaign-analytics.enum';
import { Observable } from 'rxjs';

export interface IMaterialResponse<T> {
  last_update: string;
  material_type: EMaterialType;
  stream_id: string;
  id: string;
  data: T;
}

@Injectable({
  providedIn: 'root',
})
export class DeliverableAnalyticsContentService {
  private readonly http = inject(HttpClient);

  public getMaterial<T>(materialType: EMaterialType, socialContentId: string): Observable<IApiResponse<T>> {
    return this.http.get<IApiResponse<T>>(`/materials`, {
      params: {
        material_type: materialType,
        social_content_id: socialContentId,
      },
    });
  }

  public getMaterialForExport<T>(
    exportId: string,
    materialType: EMaterialType,
    socialContentId: string,
  ): Observable<IApiResponse<T>> {
    return this.http.get<IApiResponse<T>>(`/materials/export/${exportId}`, {
      params: {
        material_type: materialType,
        social_content_id: socialContentId,
      },
    });
  }
}
